export class ActivityOperation {
    activityOperationId: number;
    activityId: number;
    operationId: number;
    operationCode: string;
    operationName: string;
}